<app-title-bar rootBreadCrumbs="['i18n.core.navigation.assets']" titleText="i18n.core.navigation.asset-collections"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid class="grid-with-toolbar" width='100%' rowHeight='38' [dataSource]='data' [allowSorting]='true'
    [filterSettings]='filterSettings' [allowFiltering]='true' [allowPaging]='true' [pageSettings]='pageSettings'
    [editSettings]='editSettings' [searchSettings]="searchOptions" (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)" (commandClick)="commandClick($event)">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.assets.asset-collections.add-collection' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
      <e-column field='name' headerText="{{'i18n.domain.assets.asset-collections.name' | translate}}"
        clipMode='EllipsisWithTooltip' type="string">
      </e-column>
      <e-column field='token' headerText="{{'i18n.domain.assets.asset-collections.token' | translate}}"
        clipMode='EllipsisWithTooltip' type="string" [allowFiltering]="false" [allowSorting]="false">
      </e-column>
      <e-column field='isShared' headerText="{{'i18n.domain.assets.asset-collections.shared' | translate}}"
        clipMode='EllipsisWithTooltip' type="boolean" [allowFiltering]="false">
        <ng-template #template let-data>
          @if (data.isShared) {
            <div class="e-icons icon-checkmark align-middle"></div>
          }
        </ng-template>
      </e-column>
      <e-column field='sharedUntilDate' headerText="{{'i18n.domain.assets.asset-collections.shared-until' | translate}}"
        clipMode='EllipsisWithTooltip' type="date" format="dd.MM.yyyy">
      </e-column>
      <e-column field='createdBy' headerText="{{'i18n.domain.assets.asset-collections.created-by' | translate}}"
        clipMode='EllipsisWithTooltip' type="string">
      </e-column>
      <e-column headerText="" [commands]='gridCommands' [allowFiltering]="false" textAlign="left" width="150px"></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-asset-collections-edit [editForm]="gridEditForm" [assets]="data.assets"></app-asset-collections-edit>
    </ng-template>
  </ejs-grid>
</div>
